/* Static posters remain usable without JS; each animation plays for at most 4s on every viewport entry. */
(function () {
  'use strict';
  if (window.PlusPetCategoryVideo) return;
  var mounts = new WeakMap();
  // Shopify's derived 480p files are ~6x larger than these uploaded originals.
  // Bind by media identity so changing/clearing the native picker never keeps an old clip.
  var optimizedSources = {
    // Production IDs for the same 24 fps uploads; IDs differ between stores.
    '32836941676681': 'https://cdn.shopify.com/videos/c/o/v/31478f40d9b540c58b48febf978fd884.mp4',
    '32836942954633': 'https://cdn.shopify.com/videos/c/o/v/84b85c610ce7433d83bdde21bff78ebe.mp4',
    '44853537800490': 'https://cdn.shopify.com/videos/c/o/v/31478f40d9b540c58b48febf978fd884.mp4',
    '44853537767722': 'https://cdn.shopify.com/videos/c/o/v/84b85c610ce7433d83bdde21bff78ebe.mp4',
    '44853368521002': 'https://cdn.shopify.com/videos/c/o/v/7d43112efa5b4f37b464b00a15f8dec5.mp4',
    '44853368488234': 'https://cdn.shopify.com/videos/c/o/v/2340e6c940ab4e60b3b03ef44b0d62d6.mp4'
  };
  function mount(root) {
    if (mounts.has(root)) return mounts.get(root);
    var nodes = Array.from(root.querySelectorAll('[data-category-video]'));
    if (!nodes.length || !window.IntersectionObserver) return function () {};
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var connection = navigator.connection;
    var disposed = false, ready = false, idleId, timer;
    var states = nodes.map(function (node) {
      var video = node.querySelector('video'), image = node.querySelector('img');
      return { node: node, video: video, image: image, visible: false, active: false, attempt: 0, failed: false, finished: false, posterReady: !!(image && image.complete && image.naturalWidth) };
    });
    function allowed() {
      return !motion.matches && !(connection && (connection.saveData || /^(slow-)?2g$/.test(connection.effectiveType)));
    }
    function update(state) {
      if (disposed) return;
      var eligible = ready && state.visible && state.posterReady && allowed() && document.visibilityState === 'visible' && !state.failed && !state.finished;
      if (!eligible) {
        if (state.active) { state.attempt += 1; state.video.pause(); state.active = false; }
        if (!allowed()) state.node.classList.remove('is-video-playing');
        return;
      }
      if (state.active) return;
      state.active = true;
      state.video.muted = true;
      if (!state.video.hasAttribute('src')) state.video.src = optimizedSources[state.video.dataset.videoId] || state.video.dataset.videoSrc;
      var generation = ++state.attempt;
      var attempt = state.video.play();
      if (attempt && attempt.catch) attempt.catch(function () {
        if (generation === state.attempt) fail(state);
      });
    }
    function fail(state) {
      if (disposed) return;
      state.failed = true; state.active = false;
      state.video.pause(); state.node.classList.remove('is-video-playing');
    }
    function updateAll() { states.forEach(update); }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = states.find(function (item) { return item.node === entry.target; });
        if (state) {
          if (entry.isIntersecting && !state.visible && !state.failed) {
            state.finished = false;
            if (state.video.hasAttribute('src')) state.video.currentTime = 0;
          }
          state.visible = entry.isIntersecting; update(state);
        }
      });
    }, { threshold: 0.05 });
    var listeners = [];
    function listen(target, name, cb) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(name, cb); listeners.push(function () { target.removeEventListener(name, cb); });
    }
    states.forEach(function (state) {
      listen(state.image, 'load', function () { state.posterReady = true; update(state); });
      listen(state.image, 'error', function () { state.posterReady = true; update(state); });
      listen(state.video, 'playing', function () {
        if (state.active && allowed()) state.node.classList.add('is-video-playing');
      });
      listen(state.video, 'error', function () { fail(state); });
      listen(state.video, 'ended', function () { state.finished = true; state.active = false; });
      listen(state.video, 'timeupdate', function () {
        if (state.video.currentTime >= 4) { state.finished = true; update(state); }
      });
    });
    function schedule() {
      if (disposed || idleId !== undefined || timer !== undefined) return;
      function start() { if (disposed) return; ready = true; states.forEach(function (s) { observer.observe(s.node); }); }
      if (window.requestIdleCallback) idleId = window.requestIdleCallback(start, { timeout: 2000 });
      else timer = window.setTimeout(start, 200);
    }
    listen(window, 'load', schedule);
    listen(document, 'visibilitychange', updateAll);
    listen(motion, 'change', updateAll);
    listen(connection, 'change', updateAll);
    if (document.readyState === 'complete') schedule();
    function destroy() {
      if (disposed) return;
      disposed = true; observer.disconnect(); listeners.forEach(function (remove) { remove(); });
      states.forEach(function (s) { s.video.pause(); });
      if (idleId !== undefined && window.cancelIdleCallback) window.cancelIdleCallback(idleId);
      if (timer !== undefined) window.clearTimeout(timer);
      mounts.delete(root);
    }
    mounts.set(root, destroy);
    return destroy;
  }
  function init(root) {
    if (root.matches && root.matches('[data-category-video-section]')) mount(root);
    root.querySelectorAll('[data-category-video-section]').forEach(mount);
  }
  window.PlusPetCategoryVideo = { mount: mount };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var destroy = mounts.get(event.target); if (destroy) destroy();
    event.target.querySelectorAll('[data-category-video-section]').forEach(function (root) { var cleanup = mounts.get(root); if (cleanup) cleanup(); });
  });
})();
